import { Theme } from "@mui/material";

export const getFilterDialogColors = (theme: Theme) => ({
  headingColor:
    (theme.palette as any).text?.heading ?? theme.palette.text.primary,
  labelColor: (theme.palette as any).text?.label ?? "#6B7280",
  dostStone: (theme.palette as any).dostStone ?? "#D0D2E0",
  dostDark:
    (theme.palette as any).dostDark ?? theme.palette.primary.light ?? "#001D3F",
});

export const filterDialogRootSx = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
} as const;

export const filterDialogTriggerRowSx = {
  py: 1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
} as const;

export const filterDialogTriggerButtonSx = {
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
} as const;

export const getFilterDialogChipsRowSx = (_dostStone: string) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
  py: 1.25,
  alignItems: "center",
});

export const filterChipSx = {
  borderRadius: "999px",
  height: "26px",
  fontSize: "12px",
  bgcolor: "secondary.light",
  color: "secondary.dark",
  border: "1px solid",
  borderColor: "secondary.main",
  "& .MuiChip-label": { px: 1.5, fontWeight: 400 },
  "& .MuiChip-deleteIcon": {
    fontSize: "14px",
    color: "secondary.dark",
    ml: "-4px",
    mr: "6px",
    "&:hover": { color: "secondary.darker" },
  },
} as const;

export const filterChipStyles = {
  bgcolor: "text.activeTab",
  color: "secondary.darker",
  border: "1px solid",
  borderColor: "secondary.darker",
  borderRadius: "999px",
  fontWeight: 500,
  px: 0.5,
  "& .MuiChip-deleteIcon": {
    color: "secondary.darker",
    backgroundColor: "transparent",
    "&:hover": {
      color: "secondary.darker",
      backgroundColor: "transparent",
    },
  },
};

export const filterDialogHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 3,
  pt: 3,
  pb: 2,
} as const;

export const filterDialogContentSx = {
  px: 3,
  py: 2.5,
} as const;

export const filterDialogFooterDividerSx = {
  mt: 2,
  mx: -3,
  mb: 2,
} as const;

export const filterDialogFooterSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
} as const;

export const filterDialogClearButtonSx = {
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
} as const;

export const getFilterDialogApplyButtonSx = (dostDark: string) => ({
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  backgroundColor: `${dostDark} !important`,
  "&:hover": { backgroundColor: `${dostDark}dd !important` },
});
